import { useState, useEffect, Fragment } from "react";
import { Card, Col, Row, Table, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import {ArrowLeftCircle, PersonAdd, PencilSquare} from "react-bootstrap-icons";
import { useSelector, useDispatch  } from "react-redux";
import { useLazyGetContractOwnerAndRenterDetailsQuery, useLazyGetPropertyUnitDetailsQuery } from "app/redux/Building/buildingApi";
import Breadcrumb from "app/components/Breadcrumb";
import useFullPageLoader from "app/hooks/useFullPageLoader ";
import { format } from "date-fns";
import AddEditOwnerships from "../Owership/AddEditOwnerships";
import AddEditRenter from "../Owership/AddEditRenter";
import AddEditContractPerson from "../Owership/AddEditContractPerson";

function ContractDetails({ open, handleContractClose, eventObject }) {
    const [addownershipModalState, setAddownershipModalState] = useState({
        dialogValues: null,
        showEditorDialog: false,
        screenType: '',
        OwnershipId: 0,
        OwnershipDate: "",
        OwnerShipEndDate: ""
    });
    const [addrenterModalState, setAddrenterModalState] = useState({
        renterDialogValues: null,
        renterShowEditorDialog: false,
        renterScreenType: '',
        renterId: 0,
        renterOwnershipDate: "",
        renterOwnerShipEndDate: "",
        OriginalRenterStartDate: "",
        OriginalRenterEndDate: ""
    });
    const [addContactPersonModalState, setAddContactPersonModalState] = useState({
        contractPersonDialogValues: null,
        contractPersonShowEditorDialog: false,
        contractPersonScreenType: '',
        contractPersonOwnershipDate: "",
        contractPersonOwnerShipEndDate: ""
    });
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [showPreviousOwnerChecked, setShowPreviousOwnerCheckedState] = useState(false);
    const [AllowOwnershipChangeFromExternal, setAllowOwnershipChangeFromExternalState] = useState(false);
    const [AllowRentalChangeFromExternal, setAllowRentalChangeFromExternalState] = useState(false);
    const [getContractOwnerAndRenterDetails] = useLazyGetContractOwnerAndRenterDetailsQuery();
    const [getPropertyUnitDetails] = useLazyGetPropertyUnitDetailsQuery();
    const { selectedCompanyId } = useSelector((state) => state.company);
    const[contractDetails, setContractDetails] = useState({});
    const[ownerShipDetails, setOwnerShipDetails] = useState([]);
    const[propertyUnitDetails, setPropertyUnitDetails] = useState({});
    const today = new Date();

    const dispatch = useDispatch();
    const[ContractNumber, setContractNumber] = useState(eventObject.ContractNumber);
    const[ContractId, setContractId] = useState(eventObject.ContractId);
    //let ContractId = eventObject.ContractId;
    let PropertyUnitId = eventObject.PropertyUnitId;
    let PropertyUnitName = eventObject.PropertyUnitName;

    useEffect(() => {
        if(ContractId && PropertyUnitId){
            getContractDetail();
        }
        else if(PropertyUnitId){
            getPropertyUnitDetailData(PropertyUnitId);
        }
        else{
            handleContractClose();
        }
        
    }, []);

    const getPropertyUnitDetailData = (PropertyUnitId) => {
        showLoader();
        getPropertyUnitDetails({
            PropertyUnitId: PropertyUnitId,
          }).then((result) => {
            hideLoader();
            if (result && result.data && result.data.data) {
                console.log('PropertyUnit Details : ', result.data.data);
                setPropertyUnitDetails(result.data.data);
                const tempData = result.data.data;
                if(tempData){
                    setContractId(tempData.ContractID);
                    setContractNumber(tempData.ContractNumebr);
                    if(tempData.ContractID) {
                        getContractDetail();
                    }
                }
                else{
                    handleContractClose();
                }
            }
          });
    }

    const getContractDetail = () => {
        showLoader();
        getContractOwnerAndRenterDetails({
            ContractId: ContractId,
            PropertyUnitId: PropertyUnitId,
          }).then((result) => {
            hideLoader();
            if (result && result.data && result.data.data) {
                //console.log('Contract details : ', result.data.data);
                setContractDetails(result.data.data);
                updateOwnerDetails(result.data.data, showPreviousOwnerChecked);
                setAllowPermissionData(result.data.data);
            }
          });
    }

    const setAllowPermissionData = (data) => {
        if(data && data.length > 0){
            if(data[0].AllowOwnershipChangeFromExternal){
                setAllowOwnershipChangeFromExternalState(data[0].AllowOwnershipChangeFromExternal);
            }
            if(data[0].AllowRentalChangeFromExternal){
                setAllowRentalChangeFromExternalState(data[0].AllowRentalChangeFromExternal);
            }
        }
    }

    const updateOwnerDetails = (data, isPreviouOwner) => {
        if(data[0] && data[0].ownerships){
            if(isPreviouOwner){
                let arrayData = data[0].ownerships;
                //console.log('OwnerDetails - ',arrayData);
                setOwnerShipDetails(arrayData);
                //formatNEwData(arrayData);
            }
            else{
                let arrayData = data[0].ownerships.filter(a => a.OwnershipType === 'Present owner');
                //console.log('OwnerDetails - ',arrayData);
                setOwnerShipDetails(arrayData);
                //formatNEwData(arrayData);
            }
        }
    }
    const toggleEditOwner = (item) => {
        //console.log('Edit - ', item);
    }
    const toggleEditorDialog = (arg, type, item) => {
        let initialValues = {};
        let OwnershipId = 0;
        let displayType = 'Add';
        if(type === 'Edit'){
            OwnershipId = item.OwnershipId;
            displayType = type;
            initialValues = item.OwnerDetails;
            //console.log('Edit - ', item);
            OwnershipDate = item.OwnershipStartDate
            OwnerShipEndDate = item.OwnerShipEndDate
        }
        if (arg && arg.toString()) {
            setAddownershipModalState((prevState) => ({ ...prevState, showEditorDialog: true, dialogValues: initialValues,
                ContractId: ContractId, OwnershipId: OwnershipId,screenType: displayType, OwnershipDate: OwnershipDate,
                OwnerShipEndDate: OwnerShipEndDate}));
        } else {
            setAddownershipModalState((prevState) => ({
            ...prevState,
            dialogValues: initialValues,
            ContractId: ContractId, OwnershipId: OwnershipId,screenType: displayType,
            OwnershipDate: OwnershipDate,
            OwnerShipEndDate: OwnerShipEndDate,
            showEditorDialog: !addownershipModalState.showEditorDialog
            }));
        }
    };

    const handleFormSubmit = async (values) => {
        getContractDetail();
        toggleEditorDialog(false);
    }

    const handleFormRenterSubmit = async (values) => {
        getContractDetail();
        toggleRenterEditorDialog(false);
    }//

    const handleFormContractPersonSubmit = async (values) => {
        getContractDetail();
        toggleContractPersonEditorDialog(false);
    }

    const toggleRenterEditorDialog = (arg, type, item) => {
        let initialValues = {};
        let renterId = 0;
        let displayType = 'Add';
        let ownershipDate = "";
        let ownershipEndDate = "";
        let contractRenterType = 0;
        if(ownerShipDetails && ownerShipDetails[0]){
            ownershipDate = ownerShipDetails[0].OwnershipStartDate;
            ownershipEndDate = ownerShipDetails[0].OwnerShipEndDate;
            if(ownershipDate){
                let originalRenterStartDate = "";
                let originalRenterEndDate = "";
                let renterdetails = [];
                if(type === 'Edit'){
                    renterId = item.ContractRenterRowID;
                    displayType = type;
                    renterdetails = item;
                    originalRenterStartDate = item.RenterStartDate;
                    originalRenterEndDate = item.RenterEndDate;
                    contractRenterType = item.contractRenterType;
                }
                initialValues = {ContractId: ContractId, renterId: renterId,renterScreenType: displayType, OwnershipDate: ownershipDate,
                    OwnerShipEndDate: ownershipEndDate,
                    OriginalRenterStartDate: originalRenterStartDate,OriginalRenterEndDate: originalRenterEndDate,
                    contractRenterType: contractRenterType}
                if (arg && arg.toString()) {
                    setAddrenterModalState((prevState) => ({ ...prevState, renterShowEditorDialog: true, 
                        renterDialogValues: initialValues,renterdetails: renterdetails
                        }));
                } else {
                    setAddrenterModalState((prevState) => ({
                        ...prevState,renterDialogValues: initialValues,renterdetails: renterdetails,
                        renterShowEditorDialog: !addrenterModalState.renterShowEditorDialog
                    }));
                }
            }
        }
        
    };

    const toggleContractPersonEditorDialog = (arg, type, item) => {
        let initialValues = {};
        let displayType = 'Add';
        let ownershipDate = "";
        let ownershipEndDate = "";
        if(ownerShipDetails && ownerShipDetails[0]){
            ownershipDate = ownerShipDetails[0].OwnershipStartDate;
            ownershipEndDate = ownerShipDetails[0].OwnerShipEndDate;
            if(ownershipDate){
                let persondetails = [];
                if(type === 'Edit'){
                    displayType = type;
                    persondetails = item;
                }
                initialValues = {ContractId: ContractId, screenType: displayType, OwnershipDate: ownershipDate,
                    OwnerShipEndDate: ownershipEndDate}
                if (arg && arg.toString()) {
                    setAddContactPersonModalState((prevState) => ({ ...prevState, contractPersonShowEditorDialog: true, 
                        contractPersonDialogValues: initialValues,persondetails: persondetails
                        }));
                } else {
                    setAddContactPersonModalState((prevState) => ({
                        ...prevState,contractPersonDialogValues: initialValues,persondetails: persondetails,
                        contractPersonShowEditorDialog: !addContactPersonModalState.contractPersonShowEditorDialog
                    }));
                }
            }
        }
        
    };


    let { dialogValues, showEditorDialog, screenType, OwnershipId, OwnershipDate, OwnerShipEndDate } = addownershipModalState;

    let { renterDialogValues, renterShowEditorDialog, renterdetails} = addrenterModalState;

    let { contractPersonDialogValues, contractPersonShowEditorDialog, persondetails} = addContactPersonModalState;
    
    return(
        <Fragment>
            {!showEditorDialog && !renterShowEditorDialog && !contractPersonShowEditorDialog &&
            <div>
                <div>
                    <div className="viewer_actions px-3 mb-3 d-flex align-items-center justify-content-between">
                        <Breadcrumb routeSegments={[{ name: "Unit", path: "/" }, { name: "Kontrakt: " + ContractNumber}]} />

                        <div className="d-flex align-items-center gap-2">
                            <Button className="mb-3" variant="primary" onClick={() => {
                                        handleContractClose();}}>
                                <ArrowLeftCircle className={'me-2'} size={17}></ArrowLeftCircle>
                                Tilbake
                            </Button>
                        </div>
                    </div>
                
                </div>

                <section className="basic-action-bar">
                    <Row>
                        <Col lg={8} className="mb-4"> 
                            <Card>
                                <Card.Header className="py-3">
                                    <Card.Title className="mb-0"> 
                                        <Row>
                                            <Col lg={2}> 
                                                Kontraktshaver
                                            </Col>
                                            <Col lg={4}> 
                                                <label className="checkbox checkbox-primary form-check-inline" >
                                                    <input
                                                    type="checkbox"
                                                    name="agree"
                                                    value={showPreviousOwnerChecked}
                                                    checked={showPreviousOwnerChecked}
                                                    onChange={(e) => {
                                                        setShowPreviousOwnerCheckedState(e.target.checked);
                                                        updateOwnerDetails(contractDetails, e.target.checked);
                                                    }}
                                                    />
                                                    <span>Vis tidligere eier</span>
                                                    <span className="checkmark"></span>
                                                </label>
                                            </Col>
                                            <Col lg={6}> 
                                                {
                                                    AllowOwnershipChangeFromExternal &&
                                                    <div style={{display:"flex",justifyContent:"flex-end"}}>
                                                        <Button variant="primary" onClick={toggleEditorDialog}>
                                                            <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                                                Eierskifte
                                                        </Button>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    </Card.Title>
                                    
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                    <Table bordered className="tbl-custom" >
                                        <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap", overflow: "auto"}}>
                                            <tr>
                                                <th className="py-3" align="left">
                                                    Eier
                                                </th>
                                                <th className="py-3" align="left">
                                                    Navn
                                                </th>
                                                <th className="py-3" align="left">
                                                    Telefon
                                                </th>
                                                <th className="py-3" align="left">
                                                    E-post
                                                </th>
                                                <th className="py-3" align="left">
                                                    Adresse
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ownerShipDetails ? ownerShipDetails
                                                .map((item, index) => (
                                                
                                                    <Fragment>
                                                        
                                                    {item.OwnerDetails &&
                                                        item.OwnerDetails
                                                        .map((owneritem, ownerindex) =>  ownerindex === 0 ? (
                                                        
                                                                <tr key={'ownershipdetails'+ index}>
                                                                    <td rowSpan={item.OwnerDetails.length} className="py-3 capitalize" align="left">
                                                                       
                                                                        
                                                                        {item.OwnershipStartDate && format(item.OwnershipStartDate, "dd.MM.yyyy")}
                                                                        -
                                                                        {item.OwnerShipEndDate && format(item.OwnerShipEndDate, "dd.MM.yyyy")}
                                                                        {item.OwnershipType === "Present owner"
                                                                            ? "(Present owner)" : ""
                                                                        }
                                                                        {item.OwnershipType === "Present owner" && AllowOwnershipChangeFromExternal
                                                                            ? 
                                                                           
                                                                            <OverlayTrigger
                                                                                trigger="hover"
                                                                                placement="right"
                                                                                overlay={<Tooltip>Legg til eier</Tooltip>}
                                                                                delay={{ show: 250, hide: 400 }}>
                                                                                <span className="ml-2 cursor-pointer text-primary"
                                                                                    onClick={() => {
                                                                                        toggleEditorDialog(true, 'Edit' , item);}}>
                                                                                        <PencilSquare size={17} className="me-2"/>
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                            : ""
                                                                        }
                                                                    </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    {owneritem.CustomerName}
                                                                </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    {owneritem.Phone}
                                                                </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    {owneritem.Email}
                                                                </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    <span>{owneritem.Address1 ? owneritem.Address1 + "," : ""}</span>
                                                                    <span>{owneritem.Address2 ? owneritem.Address2 + "," : ""}</span>
                                                                    <span>{owneritem.ZipCode ? owneritem.ZipCode + "," : ""}</span>
                                                                    <span>{owneritem.City ? owneritem.City + "," : ""}</span>
                                                                    <span>{owneritem.Country ? owneritem.Country : ""}</span>
                                                                </td>
                                                            </tr>
                                                        ): 
                                                        <tr>
                                                            <td className="py-3 capitalize" align="left">
                                                                    {owneritem.CustomerName}
                                                                </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    {owneritem.Phone}
                                                                </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    {owneritem.Email}
                                                                </td>
                                                                <td className="py-3 capitalize" align="left">
                                                                    <span>{owneritem.Address1 ? owneritem.Address1 + "," : ""}</span>
                                                                    <span>{owneritem.Address2 ? owneritem.Address2 + "," : ""}</span>
                                                                    <span>{owneritem.ZipCode ? owneritem.ZipCode + "," : ""}</span>
                                                                    <span>{owneritem.City ? owneritem.City + "," : ""}</span>
                                                                    <span>{owneritem.Country ? owneritem.Country : ""}</span>
                                                                </td>
                                                        </tr>
                                                    )
                                                    }

                                                    </Fragment>
                                            )):
                                            <tr>
                                                <td colSpan={5}>Ingen eier</td>    
                                            </tr>
                                            }
                                        </tbody>
                                    </Table>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xl={3}>
                            <Card>
                                <Card.Header className="py-3">
                                    <Card.Title className="mb-0"> 
                                    Enheter
                                        
                                    </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    {PropertyUnitName}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={8} className="mb-4"> 
                            <Card>
                                <Card.Header className="py-3">
                                    <Card.Title className="mb-0"> 
                                    <Row>
                                            <Col lg={3}> 
                                                Kontaktperson 
                                            </Col>
                                            <Col lg={9}> 
                                                {
                                                    AllowRentalChangeFromExternal ?
                                                    
                                                        contractDetails[0].ContractPersons && contractDetails[0].ContractPersons.length > 0
                                                        ?
                                                        <div style={{display:"flex",justifyContent:"flex-end"}}>
                                                            <span className="ml-2 cursor-pointer text-primary" onClick={() => {
                                                                toggleContractPersonEditorDialog(true, 'Edit' , contractDetails[0].ContractPersons);}}>
                                                                <PencilSquare size={17} className="me-2"/>
                                                            </span>
                                                        </div>
                                                        :
                                                        <div style={{display:"flex",justifyContent:"flex-end"}}>
                                                            <Button variant="primary" onClick={() => {toggleContractPersonEditorDialog(true)}}>
                                                                <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                                                Ny kontaktperson 
                                                            </Button>
                                                        </div>
                                                    :   ""
                                                    
                                                }
                                            </Col>
                                        </Row>
                                    
                                    </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                    <Table bordered className="tbl-custom" >
                                        <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                                            <tr>
                                                <th className="py-3" align="left">
                                                    Navn
                                                </th>
                                                <th className="py-3" align="left">
                                                    E-post
                                                </th>
                                                <th className="py-3" align="left">
                                                    Telefon
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contractDetails && contractDetails[0] && contractDetails[0].ContractPersons ? contractDetails[0].ContractPersons
                                                .map((item, index) => (
                                                    <tr key={'ContractRenters'+ index}>
                                                        <td className="py-3 capitalize" align="left">
                                                            {item.ContractRenterName}
                                                        </td>
                                                        <td className="py-3 capitalize" align="left">
                                                            {item.Email}
                                                        </td>
                                                        <td className="py-3 capitalize" align="left">
                                                            {item.Phone}
                                                        </td>
                                                    </tr>
                                            )): 
                                            <tr>
                                                <td colSpan={3}>Ingen kontaktperson</td>    
                                            </tr>}

                                        </tbody>
                                    </Table>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={8} className="mb-4"> 
                            <Card>
                                <Card.Header className="py-3">
                                    <Card.Title className="mb-0"> 
                                    <Row>
                                            <Col lg={3}> 
                                                Utleie 
                                            </Col>
                                            <Col lg={9}> 
                                                {
                                                    AllowRentalChangeFromExternal &&
                                                    <div style={{display:"flex",justifyContent:"flex-end"}}>
                                                        <Button variant="primary" onClick={toggleRenterEditorDialog}>
                                                            <PersonAdd className={'me-2'} size={17}></PersonAdd>
                                                            Ny Leietaker
                                                        </Button>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>
                                    
                                    </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row>
                                    <Table bordered className="tbl-custom" >
                                        <thead style={{borderTop: "1px solid #eeeeee", whiteSpace: "nowrap"}}>
                                            <tr>
                                                <th className="py-3" align="left">
                                                    Boperiode
                                                </th>
                                                <th className="py-3" align="left">
                                                    Dager
                                                </th>
                                                <th className="py-3" align="left">
                                                    Beboer/Eier(e)
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contractDetails && contractDetails[0] && contractDetails[0].ContractRenters ? contractDetails[0].ContractRenters
                                                .map((item, index) => (
                                                    <tr key={'ContractRenters'+ index}>
                                                        <td className="py-3 capitalize" align="left">
                                                            {item.RenterStartDate && format(item.RenterStartDate, "dd.MM.yyyy")}
                                                                            -                                                             
                                                            {item.RenterEndDate && format(item.RenterEndDate, "dd.MM.yyyy")}
                                                            { format(item.RenterStartDate, "yyyy-MM-dd") > format(today, "yyyy-MM-dd") ? '' :
                                                            !item.RenterEndDate ? '(Present renter)' : 
                                                             format(item.RenterEndDate, "yyyy-MM-dd") >= format(today, "yyyy-MM-dd") ? '(Present renter)' : ''
                                                            }
                                                            <span className="ml-2 cursor-pointer text-primary" onClick={() => {
                                                                toggleRenterEditorDialog(true, 'Edit' , item);}}>
                                                                <PencilSquare size={17} className="me-2"/>
                                                            </span>
                                                        </td>
                                                        <td className="py-3 capitalize" align="left">
                                                            {item.TotalDays}
                                                        </td>
                                                        <td className="py-3 capitalize" align="left">
                                                            {item.ContractRenterName}
                                                        </td>
                                                    </tr>
                                            )): 
                                            <tr>
                                                <td colSpan={3}>Ingen leietaker</td>    
                                            </tr>}

                                        </tbody>
                                    </Table>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </section>
            </div>
            }
            {showEditorDialog &&
                <AddEditOwnerships 
                show={showEditorDialog}
                initialValues={dialogValues}
                ContractId= {ContractId}
                screenType = {screenType}
                OwnershipId = {OwnershipId}
                OwnershipDate = {OwnershipDate}
                OwnerShipEndDate = {OwnerShipEndDate}
                handleFormSubmit={handleFormSubmit}
                toggleEditorDialog={toggleEditorDialog}
                />
            }
            {
                renterShowEditorDialog &&
                <AddEditRenter 
                show={renterShowEditorDialog}
                initialValues={renterDialogValues}
                renterdetails = {renterdetails}
                handleFormRenterSubmit={handleFormRenterSubmit}
                toggleRenterEditorDialog={toggleRenterEditorDialog}
                />
            }
            {
                contractPersonShowEditorDialog &&
                <AddEditContractPerson 
                show={contractPersonShowEditorDialog}
                initialValues={contractPersonDialogValues}
                persondetails = {persondetails}
                handleFormContractPersonSubmit={handleFormContractPersonSubmit}
                toggleContractPersonEditorDialog={toggleContractPersonEditorDialog}
                />
            }
            {loader}
            
            
        </Fragment>
    );
}

export default ContractDetails;